import { useBitrix } from '@context/useBitrixUser/useBitrix';
import { CircularProgress } from '@material-ui/core';
import { companyProfileService } from '@services/requests/companyProfileService';
import { DocumentFile, Field } from '@services/requests/companyProfileService/interface';
import { DocumentsData } from '@services/requests/companyProfileService/types/documentsData';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';

import { ChangeNotification } from '../../ChangeNotification';

interface DocumentItemProps {
  document: Field<DocumentFile | null>;
  code: string;
  documentsData: DocumentsData;
  isAllowEdit: boolean;
}

function DocumentItem({ document, code, documentsData, isAllowEdit }: DocumentItemProps) {
  const [fileData, setFileData] = useState<DocumentFile | null>(document.value);
  const [isChangeNotificationOpen, setIsChangeNotificationOpen] = useState<boolean>(false);
  const [isUploading, setIsUploading] = useState<boolean>(false);

  const { useBitrixUser } = useBitrix();
  const [{ bitrixUser }] = useBitrixUser().useState();

  const { enqueueSnackbar } = useSnackbar();
  const { getRootProps, getInputProps } = useDropzone({
    disabled: isUploading,
    maxFiles: 1,
    multiple: false,
    onDrop: async (files: File[]) => {
      if (files.length < 1) {
        return;
      }

      setIsUploading(true);
      const file = files[0];
      const result = await companyProfileService().UploadDocument(bitrixUser.id, {
        fieldCode: code,
        file,
      });
      setIsUploading(false);

      if ('errors' in result) {
        enqueueSnackbar(result.errors.join(' '), { variant: 'error' });
      }

      if (!result.success) {
        return;
      }

      setIsChangeNotificationOpen(true);
      setFileData(result.file);
    },
  });

  if (!fileData && !document.editable) {
    return null;
  }

  return (
    <>
      <div className="document-wrapper">
        {!fileData ? (
          <span className={'document-item'}>{document.title}</span>
        ) : (
          <a href={fileData.link} target="_blank" rel="noreferrer" className={'document-item'}>
            {document.title}
          </a>
        )}
        {document.editable && isAllowEdit && (
          <div {...getRootProps({ className: `upload-file-btn` })}>
            <span role="button" className="document-button">
              {isUploading && (
                <CircularProgress color="inherit" size={12} sx={{ marginRight: '10px' }} />
              )}
              {!fileData ? documentsData.messages.btn_upload : documentsData.messages.btn_edit}
            </span>
            <input {...getInputProps()} style={{ display: 'none' }} />
          </div>
        )}
      </div>
      <ChangeNotification
        needReviewType={false}
        isOpen={isChangeNotificationOpen}
        onClose={() => setIsChangeNotificationOpen(false)}
      />
    </>
  );
}

export { DocumentItem };
